import { Component }                   from '@angular/core';
import { DomSanitizer, SafeHtml }      from '@angular/platform-browser';
import { generateQuickGuid }           from '@cs/core/generate';
import { DashboardHtml }               from '../../models/dashboard-html';
import { DashboardPanelComponentBase } from '@cs/components/shared';
import { ArrayUtils }                  from '@cs/core';

@Component({
			   selector:    'cs-dashboard-html',
			   templateUrl: './dashboard-html.component.html'
		   })
export class DashboardHtmlComponent extends DashboardPanelComponentBase<DashboardHtml> {
	name: string;
	id = generateQuickGuid();

	safeHtml: SafeHtml;

	set data(value: DashboardHtml) {
		this._data = value;
		this.setData();
	}

	constructor(private sanitizer: DomSanitizer) {
		super();
	}

	setData(): void {
		this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this._data.html);
	}

	dataChanged(value: DashboardHtml) {

	}

	update(data: DashboardHtml): void {

		if (this._data && ArrayUtils.isEqual(this._data, data))
			return;

		this._data = data;
		this.setData();
	}
}
